import ModulePanel from "./ModulePanel";
import { resolveOpenTransactionId } from "../api/homePageApi";
import CategoryAnalysisDetailPane from "./CategoryAnalysisDetailPane";

const MODULE_KEY = "categoryAnalysis";
const MODULE_LABEL = "Category Analysis";

/**
 * Deep link to the real Category Analysis page for one record — same
 * ?type=&id=&user_id=&customer_id= shape Discovery/Brand Audit already use.
 * `type` is read by CategoryAnalysis.js's own deep-link effect purely as a
 * truthiness gate (`if (id && type && user_id ...)`) — Category Analysis has
 * no brand/product distinction, so the value itself is never used for
 * anything past that check; "brand" is passed only to satisfy it, same as
 * the hardcoded "brand" CategoryAnalysis.js itself passes at its other
 * loadCategoryAnalysis() call sites.
 */
function buildFullViewUrl(record, { userId, customerId }) {
  if (!record?.transactionId || !userId) return null;
  const params = new URLSearchParams({
    type: "brand",
    id: resolveOpenTransactionId(record),
    user_id: userId,
    customer_id: customerId,
  });
  return `/luminaire/category-analysis?${params.toString()}`;
}

export default function CategoryAnalysisModule() {
  return (
    <ModulePanel
      moduleKey={MODULE_KEY}
      moduleLabel={MODULE_LABEL}
      weightTag="competitive leaderboard · no target brand"
      DetailPane={CategoryAnalysisDetailPane}
      buildFullViewUrl={buildFullViewUrl}
      variant="category"
    />
  );
}
